import React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
// import CloseIcon from "@mui/icons-material/Close";
import CloseIcon from "../img/svg/close_blue_new_design.svg";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialog-paper": {
    borderRadius: "var(--dialog-border-radius)",
  },
}));

export default function DefaultPopup({
  isOpen,
  setIsOpen,
  bodyText,
  subBodyText,
  btnText,
  padding = true,
  bodyTextColor,
  onConfirmClick,
}) {
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{ p: 0 }}
      fullWidth={true}
    >
      <Box
        // className="phone-dialog-header"
        sx={{
          display: "flex",
          alignItems: "baseline",
          p: "18px 29px 0 16px",
          justifyContent: "space-between",
        }}
      >
        <img src={CloseIcon} onClick={handleClose} />

        <Typography
          sx={{
            fontSize: "24px",
            textAlign: "right",
            fontFamily: 'var(--font-family) !important',
            width: "199px",
            fontWeight: 700,
            color: bodyTextColor ? bodyTextColor : "var(--red-text-color)",
            lineHeight: "28px",
          }}
        >
          {bodyText}
        </Typography>
      </Box>
      <Box>
        <DialogContent
          sx={{
            direction: "rtl",
            display: "flex",
            flexDirection: "column",
            gap: padding ? "15px" : "0px",
            marginBottom: "40px",
            pr: " 29px",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              textAlign: "right",
              fontFamily: 'var(--font-family) !important',
              color: "#565656",
            }}
          >
            {subBodyText}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 0 }}>
          <Button
            variant="contained"
            className="phone-dialog-btn phone-dialog-darkblue-btn w-100-percents"
            onClick={onConfirmClick ? onConfirmClick : handleClose}
          >
            {btnText}
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
}
